import { requestSubscription, graphql, type Environment } from 'react-relay/legacy.js';
import { type Disposable } from 'relay-runtime';

import {
    type nftItemUpdateSubscription,
    type NftItemUpdateSubscriptionInput,
} from './__generated__/nftItemUpdateSubscription.graphql.ts';

export default function nftItemUpdate(
    environment: Environment,
    input: NftItemUpdateSubscriptionInput,
    onItemUpdate?: () => void
): Disposable {
    const subscription = graphql`
        subscription nftItemUpdateSubscription(
            $input: NftItemUpdateSubscriptionInput!
            $userId: String!
            $fetchUser: Boolean!
            $fetchSplitName: Boolean = false
        ) {
            nftItemUpdate(input: $input) {
                nftItem {
                    ...NftPdpLiveDetails_nftItem
                    ...NftPdpBidModalContext_nftItem
                }
                nftItemHistory {
                    ...NftPdpHistory_nftItemHistory
                }
            }
        }
    `;

    return requestSubscription<nftItemUpdateSubscription>(environment, {
        subscription,
        variables: { input, userId: '', fetchUser: false, fetchSplitName: false },
        onNext: () => {
            if (typeof onItemUpdate === 'function') {
                onItemUpdate();
            }
        },
    });
}
